import { Injectable } from "@angular/core";
import { MAP_MODULE_NAMES } from "src/models/common/EnumMapas";
import { BehaviorSubject } from "rxjs";
import { CloropetConfiguration } from "src/models/CloropetClases";
import { EncriptionService } from "src/app/features/shared/services/Encription.service";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { SessionService } from "src/app/features/shared/services/Session.service";
import { HierarchyLevel } from "../../polygon-selector-with-levels/models/polygon-selector-with-levels.models";
import { TwoLevelsSelectorLayerControlService } from "./TwoLevelsSelectorLayerControl.service";


@Injectable({
  providedIn: "root",
})
export class TwoLevelsSelectorService {
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  
  isVisible: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(private sessionService:  SessionService, 
      private localStorageService:  LocalStorageService, 
      private encriptionService:  EncriptionService,
      private twoLevelsSelectorLayerControlService: TwoLevelsSelectorLayerControlService){
  }

  setLoading(isLoading: boolean){
    this.isLoading.next(isLoading);
  }

  setIsVisible(resp: boolean) {
      this.isVisible.next(resp);
  }

  getIsVisible() {
    return this.isVisible.asObservable();
  }

  async loadLayers(): Promise<HierarchyLevel[]> {
    try {
      // this.twoLevelsSelectorLayerControlService.configure(this.selectorWithLevelsPrefixAdd);
              
      const hierarchyLevels = await this.twoLevelsSelectorLayerControlService.loadLayersFromAPI(1);
      // el dummy
      // const hierarchyLevels = await this.twoLevelsSelectorLayerControlService.loadLayersFromAssetsDummy();
      await this.twoLevelsSelectorLayerControlService.createAllSourcesAndLayers();
      return hierarchyLevels;
    } catch (error) {
      const hierarchyLevels = await this.twoLevelsSelectorLayerControlService.loadLayersFromAssetsDummy();
      return hierarchyLevels;
    }
  }

  destroyLayers(): void {
    this.twoLevelsSelectorLayerControlService.destroy();
  }

}